import { motion } from "framer-motion";
import { TRUST } from "../data";

export const TrustStrip = () => {
  return (
    <section data-testid="trust-strip" className="relative z-20 -mt-16 px-5 md:-mt-20 md:px-10">
      <div className="mx-auto grid max-w-[1200px] grid-cols-1 gap-4 md:grid-cols-3">
        {TRUST.map((t, i) => (
          <motion.div
            key={t.label}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, delay: i * 0.12, ease: [0.16, 1, 0.3, 1] }}
            data-testid={`trust-card-${i}`}
            className="chrome-inset group rounded-2xl border border-white/12 bg-white/[0.04] p-7 backdrop-blur-2xl transition-colors duration-300 hover:bg-white/[0.07]"
          >
            <div className="font-display text-3xl font-700 chrome-text md:text-4xl">{t.stat}</div>
            <div className="mt-3 font-accent text-[13px] uppercase leading-snug tracking-[0.18em] text-neutral-400">
              {t.label}
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};
